export default class CustomerActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static SUCCESS_DATA='SUCCESS_DATA';
  static GET_HELPER_CUSTOMER='GET_HELPER_CUSTOMER';
  static GET_HELPER_CUSTOMER_FULL='GET_HELPER_CUSTOMER_FULL';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static LOG_DATA='LOG_DATA';

  static submit(){
    return {
      type: CustomerActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: CustomerActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: CustomerActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: CustomerActions.VIEW_DATA,
      payload: data
    };
  }

  static log(data) {
    return {
      type: CustomerActions.LOG_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: CustomerActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: CustomerActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: CustomerActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: CustomerActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: CustomerActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: CustomerActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: CustomerActions.RESET_DATA,
    };
  }

  static helper(data){
    return {
      type: CustomerActions.GET_HELPER_CUSTOMER,
      payload:data
    };
  }
  static helperFull(data){
    return {
      type: CustomerActions.GET_HELPER_CUSTOMER_FULL,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: CustomerActions.ERROR_SERVER,
      payload: error
    };
  }
}

